export default "__VITE_ASSET__cbe4be6f__"